import React, { Component as C, cloneElement } from "react"
import PropTypes from "prop-types"
import Button from "./button.jsx"
import Content from "./content.jsx"

import styles from "./dialog.less"

export default class extends C {
  static defaultProps = {
    actions: [],
  }

  static propTypes = {
    actions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
    className: PropTypes.string,
    contentDisabled: PropTypes.bool,
    linkText: PropTypes.string,
    linkDataQa: PropTypes.string,
    linkDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    position: PropTypes.string,
    isSmartPositionCalculation: PropTypes.bool,
    isBackgroundTransparent: PropTypes.bool,
    getButton: PropTypes.any,
  }

  state = {
    showDialog: false,
  }

  showDialog = (event) => {
    if (this.state.showDialog) {
      return
    }

    if (this.props.onClick) {
      this.props.onClick()
    }

    event.preventDefault()

    this.setState({
      showDialog: true,
    })
  }

  hideDialog = () => {
    this.setState({
      showDialog: false,
    })

    this.props.onClose && this.props.onClose()
  }

  setButtonRef = (buttonRef) => {
    this._butonRef = buttonRef
  }

  getButtonRef = () => this._butonRef

  render() {
    return (
      <div className={styles.controlsContainer}>
        {this.props.getButton != null ? (
          this.props.getButton({
            setRef: this.setButtonRef,
            isActive: this.state.showDialog,
            onClick: this.showDialog,
          })
        ) : (
          <Button
            setRef={this.setButtonRef}
            text={this.props.linkText}
            className={this.props.linkClassName}
            disabled={this.props.linkDisabled}
            dataQa={this.props.linkDataQa}
            isActive={this.state.showDialog}
            onClick={this.showDialog}
          />
        )}
        {this.state.showDialog ? (
          <Content
            getAncorRef={this.getButtonRef}
            actions={this.props.actions}
            contentDisabled={this.props.contentDisabled}
            classNameDialog={this.props.classNameDialog}
            disabled={this.props.disabled}
            className={this.props.className}
            fixScrollbar={this.props.fixScrollbar ? this.props.fixScrollbar.bind(this) : null}
            close={this.hideDialog}
            position={this.props.position}
            isSmartPositionCalculation={this.props.isSmartPositionCalculation}
            isBackgroundTransparent={this.props.isBackgroundTransparent}>
            {this.props.children}
          </Content>
        ) : null}
      </div>
    )
  }
}
